import {
  Bath,
  Coffee,
  Users,
  ArrowUpDown,
  DoorOpen,
  Car,
  Dumbbell,
  Stethoscope,
  Utensils,
  BookOpen,
  Printer,
  Mailbox,
  Package,
  Shirt,
  Trash2,
  Bike,
  Home,
  Briefcase,
  Store,
  MapPin,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const AMENITY_ICONS: Record<string, LucideIcon> = {
  washroom: Bath,
  restroom: Bath,
  bathroom: Bath,
  kitchen: Coffee,
  'break-room': Coffee,
  'meeting-room': Users,
  'conference-room': Users,
  elevator: ArrowUpDown,
  lift: ArrowUpDown,
  lobby: DoorOpen,
  entrance: DoorOpen,
  parking: Car,
  garage: Car,
  gym: Dumbbell,
  fitness: Dumbbell,
  'medical-room': Stethoscope,
  'first-aid': Stethoscope,
  cafeteria: Utensils,
  canteen: Utensils,
  library: BookOpen,
  'print-room': Printer,
  mailroom: Mailbox,
  storage: Package,
  locker: Shirt,
  'waste-area': Trash2,
  'bike-storage': Bike,
  lounge: Home,
  office: Briefcase,
  retail: Store,
};

const DEFAULT_AMENITY_ICON = MapPin;

interface AmenityIconProps {
  type: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export function AmenityIcon({ type, size = 'md', className }: AmenityIconProps) {
  const normalizedType = type?.toLowerCase().replace(/\s+/g, '-') || '';
  const Icon = AMENITY_ICONS[normalizedType] || DEFAULT_AMENITY_ICON;

  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
  };

  const containerSizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  return (
    <div
      className={cn(
        'bg-primary/10 rounded-xl flex items-center justify-center text-primary',
        containerSizes[size],
        className
      )}
    >
      <Icon className={sizes[size]} />
    </div>
  );
}
